import {ContainerFacade} from '@igp/shared/ioc-container';
import type {IDownloadStrategy} from '@igp/shared/redux/download';
import type {IEntityReadService} from '@igp/shared/redux/entity';
import type {EntityType} from '@models';

import {RepaymentLogDownloadClientStrategy, RepaymentLogDownloadServerStrategy} from './downloadStrategy';
import {RepaymentLogEpicsBuilder} from './epics';
import {RepaymentLogService} from './service';
import type {RepaymentLogViewModelKeys} from './types';
import {RepaymentLogServiceTypes} from './types';

export class RepaymentLogContainerFacade extends ContainerFacade {
    bindAll() {
        this._container.bind<IEntityReadService<EntityType>>(RepaymentLogServiceTypes.service).to(RepaymentLogService);
        this._container
            .bind<IDownloadStrategy<RepaymentLogViewModelKeys>>(RepaymentLogServiceTypes.downloadClientStrategy)
            .to(RepaymentLogDownloadClientStrategy);
        this._container
            .bind<IDownloadStrategy<RepaymentLogViewModelKeys>>(RepaymentLogServiceTypes.downloadServerStrategy)
            .to(RepaymentLogDownloadServerStrategy);
        this._container.bind(RepaymentLogServiceTypes.epicsBuilder).to(RepaymentLogEpicsBuilder);
    }
}
